module.exports = __webpack_public_path__ + "img/11.395c1ad2.png";